import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import {
  ContainerCardBlue,
  ContainerTurnosRecepcionadosLabo,
  TurnosRecepcionadosLaboBody,
} from "./localStyle";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { useContext } from "react";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";

const TurnoRecepcionadoLabo = ({ turnoActual }) => {
  const { pasoDispatch, turnosSeleccionadosState } =
    useContext(AutocheckContext);
  const listaTurnos = turnosSeleccionadosState.turnosSeleccionados.data;
  const consultorio = listaTurnos[turnoActual]?.consultorio;
  const centro = listaTurnos[turnoActual]?.centro;

  const handleVolver = () => {
    setPaso("HomeLabo")(pasoDispatch);
  };

  return (
    <LayoutPasos
      handleClick={handleVolver}
      title={"AUTO CHECK IN"}
      subtitle={""}
      type={"no-circle"}
    >
      <CardBlueHeart
        medico={"Laboratorio"}
        turnoTitle={"Laboratorio"}
        pasoActual={turnoActual + 1}
        pasoTotal={listaTurnos.length}
      />
      <ContainerTurnosRecepcionadosLabo>
        <TurnosRecepcionadosLaboBody>
          <h1>¡Terminamos!</h1>
          <span className="subtitle">Ya recepcionaste tu turno</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="146"
            height="146"
            viewBox="0 0 100 100"
          >
            <circle class="circle" cx="50" cy="50" r="45"></circle>
            <path class="check" d="M25 50 L40 65 L75 30"></path>
          </svg>

          <ContainerCardBlue>
            <span className="container-text">
              Por favor acerquese a la sala de espera
              {consultorio && <span className="bold">del {consultorio}</span>}
              <span> en el centro</span>
              <span className="bold"> {centro} </span>
            </span>
          </ContainerCardBlue>
        </TurnosRecepcionadosLaboBody>
        <button
          className="TurnoRecepcionadoLabo-btnSalir"
          onClick={handleVolver}
        >
          Volver
        </button>
      </ContainerTurnosRecepcionadosLabo>
    </LayoutPasos>
  );
};

export default TurnoRecepcionadoLabo;
